import PropTypes from 'prop-types';

/**
 * InsightContent component - Displays analytical conclusions as content
 */
const InsightContent = ({ item }) => {
	return (
		<div className='insight-content'>
			<div className='insight-text'>{item.content}</div>
		</div>
	);
};

InsightContent.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.string.isRequired,
		content: PropTypes.string,
		category: PropTypes.string,
		is_key: PropTypes.bool,
		source: PropTypes.string,
	}).isRequired,
};

export default InsightContent;
